module.exports = __webpack_public_path__ + "static/cb-image-3c03ba09c5dc2484d547f45375323854.jpg";